import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FabButtonGroupComponent } from './fabbuttongroup.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { HttpModule } from '@angular/http';
import { NgModule } from '@angular/core';

import { MatInputModule, MatIconModule, MatButtonModule, MatSelectModule, MatTooltipModule } from '@angular/material';

@NgModule({
    imports: [
         BrowserAnimationsModule, FormsModule, MatIconModule, MatButtonModule, MatInputModule, MatSelectModule, MatTooltipModule
    ],
    exports: [FabButtonGroupComponent],
    declarations: [FabButtonGroupComponent]
})
export class FabButtonGroupModule {
}